<template>
  <aside class="menu zul-sidebar" v-bind:class="{ 'is-close': !isMenuOpen }">
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="updateMenu(!isMenuOpen)"
    ></button>
    <div class="p-1">
      <h2 class="title is-menu-title sidebar-title">
        <span class="is-blue">Zul</span>
        <span class="is-blue">Digital</span>
        <span class="is-white">Corporate</span>
      </h2>
      <b-menu>
        <b-menu-list>
          <b-menu-item
            label="Dashboard"
            tag="router-link"
            to="/"
            @click="updateMenu(false)"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Pedidos de compra"
            tag="router-link"
            to="/compras"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Extrato"
            tag="router-link"
            to="/extrato"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Veículos"
            tag="router-link"
            to="/veiculos"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Motoristas"
            tag="router-link"
            to="/motoristas"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Configurações"
            tag="router-link"
            to="/configuracoes"
            exact
          ></b-menu-item>
          <b-menu-item
            label="Sair"
            tag="router-link"
            to="/logout"
            class="is-hidden-desktop"
            exact
          ></b-menu-item>
        </b-menu-list>
      </b-menu>
    </div>
  </aside>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    msg: String,
    isMenuOpen: Boolean,
    updateMenu: Function,
  },
  methods: {
    ...mapActions([])
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
